"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthProvider = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _utility = require("../utility");

var _AuthContext = require("./AuthContext");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


var authReducer = function authReducer(_state, action) {
  switch (action.type) {
    case _AuthContext.AuthActions.LOGIN:
      return true;

    case _AuthContext.AuthActions.LOGOUT:
      return false;

    default:
      throw new Error("Unsupported action type " + action.type);
  }
};

var AuthProvider = function AuthProvider(props) {
  var isAuthenticated = !!(0, _utility.getToken)();

  var _a = _react["default"].useReducer(authReducer, isAuthenticated),
      state = _a[0],
      dispatch = _a[1];

  var value = _react["default"].useMemo(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state]);

  return _react["default"].createElement(_AuthContext.AuthContext.Provider, (0, _tslib.__assign)({
    value: value
  }, props));
};

exports.AuthProvider = AuthProvider;